import Cookies from 'js-cookie';
import { IWebViewActionData, IWebViewUpdateActionData } from './types';

export function useWebviewCallback(
    data: IWebViewActionData,
    nativeWebFunc: any,
    getRes?: any
) {
    try {
        const isWebView = Boolean(Cookies.get('webview'));
        if (isWebView && data?.action) {
            if (
                typeof window !== 'undefined' &&
                window?.flutter_inappwebview?.callHandler
            ) {
                window?.flutter_inappwebview
                    ?.callHandler('WebViewConnect', JSON.stringify(data))
                    .then((res: any) => {
                        getRes?.(res);
                    });
            }
        } else {
            nativeWebFunc();
        }
    } catch (e) {
        nativeWebFunc();
    }
}

export function applyWebViewWithNativeHeader(data: IWebViewUpdateActionData) {
    try {
        const nativeHeaderHeight = Cookies.get('native_header_height');
        if (
            typeof window !== 'undefined' &&
            window?.flutter_inappwebview?.callHandler &&
            nativeHeaderHeight
        ) {
            window?.flutter_inappwebview
                ?.callHandler('WebViewConnect', JSON.stringify(data))
        }
    } catch (e) {
        console.error("Error in applyWebViewWithNativeHeader:", e)
    }
}

export const appViewConfigs = {
    FRESH_CAR: {
        action: 'update_appbar',
        action_value: {
            background_color: '#ffffff',
            back_button_color: '#000000',
            status_icon_brightness: "dark",
            is_appbar_transparent: false
        }
    },
    LOTTIE: {
        action: 'update_appbar',
        action_value: {
            background_color: '#ffffff',
            back_button_color: '#000000',
            status_icon_brightness: "dark",
            is_appbar_transparent: true
        }
    }
}